import { render, staticRenderFns } from "./emoj.vue?vue&type=template&id=298f4748"
import script from "./emoj.vue?vue&type=script&lang=js"
export * from "./emoj.vue?vue&type=script&lang=js"
import style0 from "./emoj.vue?vue&type=style&index=0&id=298f4748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports